import * as React from "react";
import { connect } from "react-redux";
import FooterLoggedOut from "../common/footer/FooterLoggedOut";
import OnboardingHeader from "./OnboardingHeader";
import OnboardingMainContent from "../layouts/OnboardingMainContent";
import OnboardingSidebar from "../layouts/OnboardingSidebar";
import OnboardingModal from "../onboarding/OnboardingModal";


class OnboardingLayout extends React.Component {
    constructor(props) {
        super(props);
    }

  
    render() {
        const { sidebarProps, pageHeading, showOnboardingModal} = this.props;

        return (
            <div className="container-fluid onboarding-layout-container">
                <div className="row">
                    <div className="col-12 col-lg-9 offset-lg-3">
                        <OnboardingHeader />
                    </div>
                    <div className="col-12 col-lg-3 order-lg-first d-lg-flex align-items-lg-stretch justify-content-lg-center onboarding-layout__sidebar" >
                        <OnboardingSidebar {...sidebarProps} />
                    </div>
                    <div className="col-12 col-lg-9 offset-lg-3 onboarding-layout__body">
                        <OnboardingMainContent pageHeading={pageHeading}>
                            {showOnboardingModal && <OnboardingModal />}
                            {this.props.children}
                        </OnboardingMainContent>
                    </div>
                    <div className="col-12 col-lg-9 offset-lg-3">
                        <div className="row">
                            <FooterLoggedOut />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



const mapStateToProps = (state) => {
    return {
        showOnboardingModal: state.session.showOnboardingModal,
    };
};

export default connect(mapStateToProps)(OnboardingLayout);